import { render } from "./FunkView.vue?vue&type=template&id=21540f73"
import script from "./FunkView.vue?vue&type=script&lang=js"
export * from "./FunkView.vue?vue&type=script&lang=js"

import "./FunkView.vue?vue&type=style&index=0&id=21540f73&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__